import { message } from 'antd'

let blockDepth = 0
let overlayEl: HTMLDivElement | null = null
let lastToastAt = 0

const showEncodingToast = () => {
  const now = Date.now()
  if (now - lastToastAt < 1500) return
  lastToastAt = now
  message.warning('영상 인코딩 중입니다. 잠시만 기다려 주세요.')
}

const createOverlay = () => {
  if (typeof document === 'undefined' || overlayEl) return

  overlayEl = document.createElement('div')
  overlayEl.style.position = 'fixed'
  overlayEl.style.top = '0'
  overlayEl.style.left = '0'
  overlayEl.style.right = '0'
  overlayEl.style.bottom = '0'
  overlayEl.style.background = 'rgba(0,0,0,0)'
  overlayEl.style.zIndex = '2147483647'
  overlayEl.style.cursor = 'wait'
  overlayEl.tabIndex = -1

  overlayEl.addEventListener('pointerdown', showEncodingToast, { passive: true })
  overlayEl.addEventListener('click', showEncodingToast, { passive: true })
  overlayEl.addEventListener('touchstart', showEncodingToast, { passive: true })
  overlayEl.addEventListener('keydown', showEncodingToast)
  document.body.appendChild(overlayEl)
  document.body.style.userSelect = 'none'
}

const removeOverlay = () => {
  if (!overlayEl) return
  overlayEl.removeEventListener('pointerdown', showEncodingToast)
  overlayEl.removeEventListener('click', showEncodingToast)
  overlayEl.removeEventListener('touchstart', showEncodingToast)
  overlayEl.removeEventListener('keydown', showEncodingToast)
  overlayEl.remove()
  overlayEl = null
  if (typeof document !== 'undefined') {
    document.body.style.userSelect = ''
  }
}

export const blockUI = (): void => {
  blockDepth += 1
  if (blockDepth === 1) {
    createOverlay()
  }
}

export const unblockUI = (): void => {
  if (blockDepth === 0) return
  blockDepth -= 1
  if (blockDepth === 0) {
    removeOverlay()
  }
}
